// react
import React from 'react';
// assets
import '../assets/css/bookingHeader.less';

/**
 * @description 公共头
 * @param {*} props
 * @returns {*} booking header
 */

const BookingHeader = () => {

    return (
        <div className="booking-header">
            <div className="booking-header-wrapper clear">
                <div className="header-title fl">
                    高顿网校
                </div>
            </div>
        </div>
    );
};

export default BookingHeader;